// Auto-generated i18n batch 2 (ES/EN) for client landing
// Namespaces: clHeader, clHome, clBlog, clBlogPost, clPropDetail
// es = literal Spanish source; en = natural English translation. Keys are 1:1.

export const es = {
  clHeader: {
    nav: {
      home: 'Inicio',
      sales: 'Ventas',
      rentals: 'Alquiler',
      services: 'Servicios',
      about: 'Quiénes Somos',
      blog: 'Blog',
      contact: 'Contacto',
    },
    languageLabel: 'Idioma:',
  },
  clHome: {
    loading: 'Cargando página...',
    error: {
      title: 'Error al cargar la página',
    },
    notAvailable: {
      title: 'Página no disponible',
      message: 'La página de inicio no está disponible en este momento.',
    },
    noContent: {
      title: 'Contenido no disponible',
      message: 'No hay contenido configurado para mostrar en esta página.',
    },
  },
  clBlog: {
    categories: {
      all: 'Todas',
    },
    results: {
      showing: 'Mostrando {{current}} de {{total}} artículos',
      forQuery: ' para "{{query}}"',
      inCategory: ' en {{category}}',
      none: 'No se encontraron artículos que coincidan con tu búsqueda',
    },
    card: {
      featured: 'Destacado',
      readMore: 'Leer más',
      minutes: 'min',
    },
    empty: {
      title: 'No se encontraron artículos',
      message: 'Intenta ajustar tu búsqueda o explorar otras categorías',
      seeAll: 'Ver todos los artículos',
    },
    pagination: {
      previous: 'Anterior',
      next: 'Siguiente',
    },
  },
  clBlogPost: {
    notFound: {
      title: 'Artículo no encontrado',
      message: 'El artículo que buscas no existe o ha sido removido.',
      cta: 'Ver Otros Artículos',
    },
    backToBlog: 'Volver al Blog',
    featuredBadge: 'DESTACADO',
    authorTitle: 'Autor',
    shareButton: 'Compartir Artículo',
  },
  clPropDetail: {
    notFound: {
      title: 'Propiedad no encontrada',
      message: 'La propiedad que buscas no existe o ha sido removida.',
      cta: 'Ver Otras Propiedades',
    },
    operation: {
      sale: 'VENTA',
      rent: 'ALQUILER',
    },
    featuredBadge: 'DESTACADO',
    perMonth: '/mes',
    features: {
      bedrooms: 'Dormitorios',
      bathrooms: 'Baños',
      area: 'Superficie',
      builtArea: 'Construidos',
    },
    description: 'Descripción',
    characteristics: 'Características',
    location: 'Ubicación',
    agent: {
      title: 'Agente Inmobiliario',
      role: 'Agente de Ventas',
      call: 'Llamar',
      whatsapp: 'WhatsApp',
      email: 'Email',
    },
    contact: {
      title: 'Solicitar Información',
    },
    share: {
      title: 'Compartir Propiedad',
      share: 'Compartir',
      save: 'Guardar',
    },
    similar: 'Propiedades Similares',
  },
};

export const en = {
  clHeader: {
    nav: {
      home: 'Home',
      sales: 'Sales',
      rentals: 'Rentals',
      services: 'Services',
      about: 'About Us',
      blog: 'Blog',
      contact: 'Contact',
    },
    languageLabel: 'Language:',
  },
  clHome: {
    loading: 'Loading page...',
    error: {
      title: 'Error loading the page',
    },
    notAvailable: {
      title: 'Page not available',
      message: 'The home page is not available at this time.',
    },
    noContent: {
      title: 'Content not available',
      message: 'There is no content configured to display on this page.',
    },
  },
  clBlog: {
    categories: {
      all: 'All',
    },
    results: {
      showing: 'Showing {{current}} of {{total}} articles',
      forQuery: ' for "{{query}}"',
      inCategory: ' in {{category}}',
      none: 'No articles were found matching your search',
    },
    card: {
      featured: 'Featured',
      readMore: 'Read more',
      minutes: 'min',
    },
    empty: {
      title: 'No articles found',
      message: 'Try adjusting your search or exploring other categories',
      seeAll: 'View all articles',
    },
    pagination: {
      previous: 'Previous',
      next: 'Next',
    },
  },
  clBlogPost: {
    notFound: {
      title: 'Article not found',
      message: 'The article you are looking for does not exist or has been removed.',
      cta: 'View Other Articles',
    },
    backToBlog: 'Back to Blog',
    featuredBadge: 'FEATURED',
    authorTitle: 'Author',
    shareButton: 'Share Article',
  },
  clPropDetail: {
    notFound: {
      title: 'Property not found',
      message: 'The property you are looking for does not exist or has been removed.',
      cta: 'View Other Properties',
    },
    operation: {
      sale: 'SALE',
      rent: 'RENT',
    },
    featuredBadge: 'FEATURED',
    perMonth: '/month',
    features: {
      bedrooms: 'Bedrooms',
      bathrooms: 'Bathrooms',
      area: 'Area',
      builtArea: 'Built area',
    },
    description: 'Description',
    characteristics: 'Features',
    location: 'Location',
    agent: {
      title: 'Real Estate Agent',
      role: 'Sales Agent',
      call: 'Call',
      whatsapp: 'WhatsApp',
      email: 'Email',
    },
    contact: {
      title: 'Request Information',
    },
    share: {
      title: 'Share Property',
      share: 'Share',
      save: 'Save',
    },
    similar: 'Similar Properties',
  },
};
